(() => {
  const formatter = new Intl.NumberFormat('tr-TR', {
    style: 'currency',
    currency: 'TRY',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const parseMoney = (text) => {
    const match = text?.match(/[\d.,]+/);
    if (!match) return null;

    const raw = match[0];
    const normalized = text.includes('₺')
      ? raw.replaceAll('.', '').replace(',', '.')
      : raw.replaceAll(',', '');
    const value = Number(normalized);
    return Number.isFinite(value) ? value : null;
  };

  const localizeMoney = () => {
    document.querySelectorAll('.price, .compare-at-price').forEach((element) => {
      const text = element.textContent?.trim();
      if (!text || (!text.includes('TL') && !text.includes('₺'))) return;
      const value = parseMoney(text);
      if (value === null) return;
      const formatted = formatter.format(value);
      if (text !== formatted) element.textContent = formatted;
    });
  };

  const localizeInterface = () => {
    const replacements = new Map([
      ['Home', 'Ana Sayfa'],
      ['Katalog', 'Koleksiyonlar'],
      ['Catalog', 'Koleksiyonlar'],
      ['View all', 'Tümünü gör'],
      ['You may also like', 'Bunları da beğenebilirsiniz'],
      ['Sign up', 'E-posta adresiniz'],
    ]);

    document
      .querySelectorAll(
        '.menu-list__link-title, .menu-drawer__menu-item-text, .product-list__content h3, footer nav a'
      )
      .forEach((element) => {
        const current = element.textContent?.trim();
        const replacement = replacements.get(current);
        if (replacement && current !== replacement) element.textContent = replacement;
      });
  };

  const keepWhatsAppClearOfStickyControls = () => {
    const button = document.querySelector('.novva-whatsapp-button');
    const scrollTopButton = document.querySelector('.novva-scroll-top-button');
    if (!button) return;

    const needsExtraOffset =
      window.matchMedia('(max-width: 749px)').matches &&
      (window.location.pathname.startsWith('/products/') || window.location.pathname.startsWith('/cart'));

    if (needsExtraOffset) {
      button.style.setProperty('bottom', 'calc(96px + max(14px, env(safe-area-inset-bottom)))');
      scrollTopButton?.style.setProperty('bottom', 'calc(154px + max(14px, env(safe-area-inset-bottom)))');
    } else {
      button.style.removeProperty('bottom');
      scrollTopButton?.style.removeProperty('bottom');
    }
  };

  const syncScrollTopButton = () => {
    const button = document.querySelector('.novva-scroll-top-button');
    if (!button) return;

    if (button.dataset.initialized !== 'true') {
      button.dataset.initialized = 'true';
      button.addEventListener('click', () => {
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    }

    const isVisible = window.scrollY > Math.max(420, window.innerHeight * 0.55);
    button.classList.toggle('is-visible', isVisible);
    button.setAttribute('aria-hidden', String(!isVisible));
    button.tabIndex = isVisible ? 0 : -1;
  };

  const syncMobileStickyAddToCart = () => {
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    const sticky = document.querySelector('sticky-add-to-cart');
    const stickyBar = sticky?.querySelector('[ref="stickyBar"]');
    const primaryBuyButtons = document.querySelector('.product-details .buy-buttons-block');
    if (!sticky || !stickyBar || !primaryBuyButtons) return;

    const variantAvailable = sticky.dataset.variantAvailable === 'true';
    const standardMode = !document.body.classList.contains('novva-custom-size-selected');
    const purchaseAreaPassed = primaryBuyButtons.getBoundingClientRect().bottom < 0;
    const footer = document.querySelector('footer');
    const footerIsClear = !footer || footer.getBoundingClientRect().top > window.innerHeight - 24;
    const shouldShow = variantAvailable && standardMode && purchaseAreaPassed && footerIsClear;

    if (stickyBar.dataset.stuck !== String(shouldShow)) {
      stickyBar.dataset.stuck = String(shouldShow);
    }
  };

  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      localizeMoney();
      localizeInterface();
      keepWhatsAppClearOfStickyControls();
      syncScrollTopButton();
      syncMobileStickyAddToCart();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }

  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true,
  });

  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('scroll', schedule, { passive: true });
  document.addEventListener('novva:size-change', schedule);
})();
